import interfaceTeacher from './interface-teacher'

let mergeInterface = Object.assign({}, interfaceTeacher)

export default mergeInterface



// WEBPACK FOOTER //
// ./src/common/api/interface.js